import React from "react";
import { Link, useSearchParams } from "react-router-dom";

const useSortableTableHeader = () => {
  let [searchParams] = useSearchParams();

  const TableHeader = (props) => {
    const { items = [] } = props;

    let paramsString = "?";
    for (const [key, value] of searchParams.entries()) {
      if (!["sort", "order"].includes(key)) {
        paramsString += `${key}=${value}&`;
      }
    }

    if (paramsString) {
      paramsString = paramsString.trimEnd();
      // paramsString = paramsString.endsWith("&")
      //   ? paramsString.slice(0, -1)
      //   : paramsString;
    }

    const order = searchParams.get("order") || "asc";
    const field = searchParams.get("sort");

    const defaultHeader = {
      className: "both",
      sort: false,
      field: null,
    };

    const headers = [];
    items.forEach((element) => {
      let header = { ...defaultHeader, ...element };
      if (header.sort) {
        if (!header.field) {
          header.field = header?.label.toLowerCase();
        }

        if (field === header.field) {
          header = {
            ...header,
            active: true,
            direction: order === "asc" ? "desc" : "asc",
          };
        }
      }

      headers.push(header);
    });

    return (
      <thead>
        <tr>
          {headers &&
            headers.length > 0 &&
            headers.map((header, index) =>
              header.sort ? (
                <th key={header.label} className={header.className}>
                  <Link
                    to={
                      header?.active
                        ? `${paramsString}sort=${header.field}&order=${header?.direction}`
                        : `${paramsString}sort=${header.field}&order=asc`
                    }
                    className={header?.active && header?.direction}
                    replace
                  >
                    {header.label}
                  </Link>
                </th>
              ) : (
                <th key={header.label} className={header.className}>
                  {header.label}
                </th>
              )
            )}
        </tr>
      </thead>
    );
  };

  return { TableHeader };
};

export default useSortableTableHeader;
